<script lang="ts">
  import { Loader } from "lucide-svelte"

  let {
    saving = $bindable(),
    title = "Sign up",
    onclick
  }: { saving: boolean; title?: string; onclick: Function } = $props()
</script>

<button
  onclick={() => onclick()}
  disabled={saving}
  class="btn big bg-lwp-blue hover:bg-blue-700 text-white inline font-bold text-center w-full justify-center"
>
  {#if saving}
    <Loader class="w-4 h-4 animate-spin" />
    Please wait...
  {:else}
    {title}
  {/if}
</button>
